import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { X, ArrowLeft, ChevronLeft, ChevronRight } from "lucide-react";
import ImgSlider from "../components/Common/ImgSlider";
import { APIUtility } from "../Api";
import Loader from "../components/Common/Loader";

const VehicleDetailModal = ({ show, onHide, entry, EntryExistData }) => {

  const [vehicleEntryData, setVehicleEntryData] = useState(null);
  const [slideIndex, setSlideIndex] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const data = [
    {
      name: "Entry at Boombarrier",
      status: "AFAMF3105202315050",
      time: "11:23:22 AM",
    },
    {
      name: "Reporting No Generated",
      status: "R12232881201",
      time: "11:30:21 AM",
    },
    {
      name: "Valid from SAP",
      status: "Validated",
      time: "11:35:11 AM",
    },
    {
      name: "Gate Entry No. Generated",
      status: "GE1210992AR",
      time: "11:37:11 AM",
    },
    {
      name: "RFID No. Generated",
      status: "22517716234",
      time: "11:40:19 AM",
    },
    {
      name: "Exit No. Generated",
      status: "76466467737",
      time: "11:56:115 AM",
    },
  ];

  const images = [
    "https://plus.unsplash.com/premium_photo-1661724753583-50fc504ca7e5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://plus.unsplash.com/premium_photo-1682724598922-64856f1c3eea?q=80&w=1771&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  ];


  const nextSlide = () => {
    setSlideIndex((prevIndex) => (prevIndex + 1) % 2);
  };

  const prevSlide = () => {
    setSlideIndex((prevIndex) => (prevIndex - 1 + 2) % 2);
  };

  const getVehicleData = async (id) => {
    setIsLoading(true);
    const data = { user_vehicle_mapping_id: id };
    try {
      const res = await APIUtility.getVehicleEntryDetails(data);

      if (res.status == 200) {
        setVehicleEntryData(res.data[0]);
        setIsLoading(false);
      } else {
        setVehicleEntryData(null);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error, "error");
    }
  };

  useEffect(() => {
    if (show) {
      // getVehicleData(entry.id)
      setCurrentIndex(entry.index);
    }
  }, [show]);

  const moveNextData = (type) => {
    if (type == "prev") {
      setCurrentIndex((prev) => (prev > 0 ? prev - 1 : 0));
    } else {
      setCurrentIndex((prev) =>
        EntryExistData.length - 1 == prev ? prev : prev + 1
      );
    }
  };

  useEffect(() => {
    const idOfData = EntryExistData[currentIndex]?.user_vehicle_mapping_id;
    getVehicleData(idOfData);
  }, [currentIndex]);

  return (
    <div>
      <Modal
        show={show}
        onHide={onHide}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className=" "
      >
        <Modal.Body className="!p-0">
          <button
            className=" absolute right-[10px] top-[10px] text-black"
            onClick={() => onHide()}
          >
            <X size={26} />
          </button>
          <div className="absolute top-[50%] translate-y-[-50%] flex items-center justify-between w-full">
            <div
              className={`bg-white w-[50px] h-[50px] rounded-full ml-[-80px] grid place-items-center cursor-pointer ${currentIndex == 0
                  ? " opacity-55 pointer-events-none"
                  : " opacity-100 pointer-events-auto"
                }`}
              onClick={() => moveNextData("prev")}
            >
              <ChevronLeft />
            </div>
            <div
              className={`bg-white w-[50px] h-[50px] rounded-full mr-[-80px] grid place-items-center cursor-pointer  ${currentIndex == EntryExistData.length - 1
                  ? " opacity-55 pointer-events-none"
                  : " opacity-100 pointer-events-auto"
                }`}
              onClick={() => moveNextData("next")}
            >
              <ChevronRight />
            </div>
          </div>
          {isLoading ? (
            <div className="flex items-center justify-center h-[70vh]">
              <Loader />
            </div>
          ) : (
            <div className="flex h-full w-full">
              <div className="w-[68%] bg-[#F9F9F7] py-[20px] px-[20px] rounded-s-xl">
                <div className="flex flex-col h-full">
                  <div className="flex items-center justify-between">
                    <h3 className="flex items-center gap-3 font-bold text-[18px] m-0 p-0">
                      <ArrowLeft
                        className="cursor-pointer"
                        onClick={() => onHide()}
                      />{" "}
                      Entry Exit Details of Vehicle:{" "}
                      {
                        vehicleEntryData?.vehicle_images[slideIndex]
                          ?.ai_app_extracted_data?.license_plate
                      }
                    </h3>
                    <p className="m-0 font-bold text-[18px]">
                      {vehicleEntryData?.vehicle_entry_date_time}
                    </p>
                  </div>
                  <div className="flex items-center justify-between mt-3 bg-white rounded-[3px] py-2 px-2 mb-2 text-[15px] select-none">
                    <h3 className="text-[18px] font-normal m-0">
                      {vehicleEntryData?.vehicle_images[slideIndex]?.image_type}
                    </h3>
                    {vehicleEntryData?.vehicle_images &&
                      vehicleEntryData?.vehicle_images.length > 1 && (
                        <div className="flex items-center gap-1">
                          <ChevronLeft
                            className={`cursor-pointer ${slideIndex > 0
                                ? "bg-stone-50 rounded-[3px] w-[4vh] h-[4vh] pointer-events-auto"
                                : "opacity-10 bg-stone-50 pointer-events-none "
                              }`}
                            onClick={() => prevSlide()}
                          />
                          <p className="m-2 font-bold font-['Roboto']">
                            {slideIndex + 1}/2
                          </p>
                          <ChevronRight
                            className={`cursor-pointer ${slideIndex < vehicleEntryData?.vehicle_images.length - 1
                                ? "bg-stone-50 rounded-[3px] w-[4vh] h-[4vh] pointer-events-auto"
                                : "opacity-10 bg-stone-50 pointer-events-none"
                              }`}
                            onClick={() => nextSlide()}
                          />
                        </div>
                      )}
                  </div>
                  <div className="w-full h-full flex-grow">
                    <ImgSlider
                      slideIndex={slideIndex}
                      imgList={vehicleEntryData?.vehicle_images}
                      show={show}
                    />
                  </div>
                </div>
              </div>
              <div className="w-[32%] py-[20px] px-[20px] bg-white rounded-r-xl">
                <h3 className="flex items-center gap-3 font-bold text-[18px] select-none">
                  Process Details
                </h3>
                <div className="mt-4 h-[70vh] overflow-y-auto hideScrollBar">
                  {vehicleEntryData?.vehicle_date_time_history?.map(
                    (item, index) => {
                      if (Object.keys(item).length > 0)
                        return (
                          <div className="" key={index}>
                            <div
                              className={` ${item.status ? "bg-ligthgreen" : "bg-lightRed"
                                } w-full flex items-center px-[10px] py-[10px] rounded-[5px] gap-2 relative ${index == 0 ? "mt-0" : "mt-[46px]"
                                }`}
                            >
                              <span className="relative">
                                {item?.status ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="21"
                                    viewBox="0 0 20 21"
                                    fill="none"
                                  >
                                    <rect
                                      width="20"
                                      height="20"
                                      transform="translate(0 0.5)"
                                      fill="#F6FBF6"
                                    />
                                    <path
                                      d="M9.99984 18.8332C5.39746 18.8332 1.6665 15.1022 1.6665 10.4998C1.6665 5.89746 5.39746 2.1665 9.99984 2.1665C14.6022 2.1665 18.3332 5.89746 18.3332 10.4998C18.3332 15.1022 14.6022 18.8332 9.99984 18.8332ZM9.16867 13.8332L15.0613 7.94061L13.8828 6.7621L9.16867 11.4762L6.81168 9.11909L5.63316 10.2977L9.16867 13.8332Z"
                                      fill="#4DB748"
                                    />
                                  </svg>
                                ) : (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17"
                                    height="18"
                                    viewBox="0 0 17 18"
                                    fill="none"
                                  >
                                    <path
                                      d="M8.335 17.17C3.7317 17.17 0 13.4383 0 8.835C0 4.2317 3.7317 0.5 8.335 0.5C12.9383 0.5 16.67 4.2317 16.67 8.835C16.67 13.4383 12.9383 17.17 8.335 17.17ZM8.335 7.65626L5.9775 5.29876L4.79876 6.4775L7.15626 8.835L4.79876 11.1925L5.9775 12.3712L8.335 10.0137L10.6925 12.3712L11.8712 11.1925L9.51374 8.835L11.8712 6.4775L10.6925 5.29876L8.335 7.65626Z"
                                      fill="#FF6161"
                                    />
                                  </svg>
                                )}

                                {vehicleEntryData?.vehicle_date_time_history -
                                  1 !==
                                  index && (
                                    <div
                                      className={`w-[1px] h-[80px] ${item?.status ? "bg-[#4DB748]" : "#FF6161"
                                        } absolute top-[100%] left-[50%] translate-x-[-50%]`}
                                    ></div>
                                  )}
                              </span>
                              <h5
                                className={`m-0 text-[16px] font-bold  font-['Roboto'] ${item?.status
                                    ? "text-[#4DB748]"
                                    : "text-[#FF6161]"
                                  }`}
                              >
                                {item.title}
                              </h5>
                            </div>
                            <div className="flex items-center justify-between float-right w-[90%] mt-3">
                              <h4
                                className={`text-[14px] font-['Roboto'] font-bold ${index == 0 ? "text-[#4DB748]" : "text-black"
                                  } m-0`}
                              >
                                {item.data}
                              </h4>
                              <p className="italic font-medium font-['Roboto'] text-[12px] text-black opacity-[0.6] m-0">
                                {item.time}
                              </p>
                            </div>
                          </div>
                        );
                    }
                  )}
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default VehicleDetailModal;
